<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <el-input  v-model="queryForm.userId"></el-input>
              </el-form-item>
<!--              <el-form-item label="考试">-->
<!--                  <el-input  v-model="queryForm.examId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="习题">
                  <el-input  v-model="queryForm.exerciseId"></el-input>
              </el-form-item>
<!--              <el-form-item label="题目JSON数据（提交试卷时备份的）">-->
<!--                  <el-input  v-model="queryForm.exerciseJson"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="我的答案">-->
<!--                  <el-input  v-model="queryForm.myAnswer"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="正确答案">-->
<!--                  <el-input  v-model="queryForm.rightAnswer"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="题目解析（提交试卷时备份的）">-->
<!--                  <el-input  v-model="queryForm.exerciseAnalysis"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="得分">-->
<!--                  <el-input  v-model="queryForm.score"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="已批改">
                  <el-input  v-model="queryForm.isCorrected"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExerciseExamRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduExerciseExamRecord"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduExerciseExamRecord(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExerciseExamRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduExerciseExamRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExerciseExamRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="userId"-->
<!--        label="用户"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="examId"-->
<!--        label="考试"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseId"
        label="习题"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseJson"
        label="题目JSON数据（提交试卷时备份的）"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="myAnswer"
        label="我的答案"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rightAnswer"
        label="正确答案"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseAnalysis"
        label="题目解析（提交试卷时备份的）"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="score"
        label="得分"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isCorrected"
        label="已批改"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduExerciseExamRecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduExerciseExamRecord(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduExerciseExamRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExerciseExamRecordStates[eduExerciseExamRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduExerciseExamRecord"
          ref="eduExerciseExamRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.userId"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="考试"
            prop="examId"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.examId"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="习题"
            prop="exerciseId"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.exerciseId"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="题目JSON数据（提交试卷时备份的）"
            prop="exerciseJson"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.exerciseJson"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="我的答案"
            prop="myAnswer"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.myAnswer"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="正确答案"
            prop="rightAnswer"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.rightAnswer"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="题目解析（提交试卷时备份的）"
            prop="exerciseAnalysis"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.exerciseAnalysis"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="得分"
            prop="score"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.score"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="已批改"
            prop="isCorrected"
          >
            <el-input
              size="small"
              v-model="eduExerciseExamRecord.isCorrected"
              :disabled="eduExerciseExamRecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExerciseExamRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExerciseExamRecordList();
                    this.getEduExerciseExamRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExerciseExamRecordList();
                    this.getEduExerciseExamRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     examId: '', //考试
                     exerciseId: '', //习题
                     exerciseJson: '', //题目JSON数据（提交试卷时备份的）
                     myAnswer: '', //我的答案
                     rightAnswer: '', //正确答案
                     exerciseAnalysis: '', //题目解析（提交试卷时备份的）
                     score: '', //得分
                     isCorrected: '', //已批改
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduExerciseExamRecordState: 'add',
                eduExerciseExamRecordStates: {
                    add: '添加详情',
                    check: '查看详情',
                    edit: '修改详情'
                },

                multipleSelection: [],
                eduExerciseExamRecordList: [],
                eduExerciseExamRecord: {
                    id: '', //
                    userId: '', //用户
                    examId: '', //考试
                    exerciseId: '', //习题
                    exerciseJson: '', //题目JSON数据（提交试卷时备份的）
                    myAnswer: '', //我的答案
                    rightAnswer: '', //正确答案
                    exerciseAnalysis: '', //题目解析（提交试卷时备份的）
                    score: '', //得分
                    isCorrected: '', //已批改
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    examId: [{ required: true, message: '考试不能为空', trigger: 'blur' }],
                    exerciseId: [{ required: true, message: '习题不能为空', trigger: 'blur' }],
                    exerciseJson: [{ required: true, message: '题目JSON数据（提交试卷时备份的）不能为空', trigger: 'blur' }],
                    myAnswer: [{ required: true, message: '我的答案不能为空', trigger: 'blur' }],
                    rightAnswer: [{ required: true, message: '正确答案不能为空', trigger: 'blur' }],
                    exerciseAnalysis: [{ required: true, message: '题目解析（提交试卷时备份的）不能为空', trigger: 'blur' }],
                    score: [{ required: true, message: '得分不能为空', trigger: 'blur' }],
                    isCorrected: [{ required: true, message: '已批改不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id,sign){
                this.queryForm.userId = id;
                this.queryForm.examId = sign;
                this.eduExerciseExamRecord.userId = id;
                this.eduExerciseExamRecord.examId = sign;
                this.getEduExerciseExamRecordList();
            },
            resetEduExerciseExamRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExerciseExamRecordList = [];
            },
            resetDialog() {
                this.eduExerciseExamRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      examId: '', //考试
                      exerciseId: '', //习题
                      exerciseJson: '', //题目JSON数据（提交试卷时备份的）
                      myAnswer: '', //我的答案
                      rightAnswer: '', //正确答案
                      exerciseAnalysis: '', //题目解析（提交试卷时备份的）
                      score: '', //得分
                      isCorrected: '', //已批改
                };
                this.getEduExerciseExamRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExerciseExamRecord = {
                      id: '', //
                      userId: '', //用户
                      examId: '', //考试
                      exerciseId: '', //习题
                      exerciseJson: '', //题目JSON数据（提交试卷时备份的）
                      myAnswer: '', //我的答案
                      rightAnswer: '', //正确答案
                      exerciseAnalysis: '', //题目解析（提交试卷时备份的）
                      score: '', //得分
                      isCorrected: '', //已批改
                };
            },
            submitForm() {
                if (this.eduExerciseExamRecordState == 'add') {
                    this.$refs.eduExerciseExamRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciseexamrecord/add`,{ ...this.eduExerciseExamRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExerciseExamRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExerciseExamRecordState == 'edit') {
                    this.$refs.eduExerciseExamRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciseexamrecord/edit`,{ ...this.eduExerciseExamRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExerciseExamRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExerciseExamRecord() {
                this.showDialog = true;
                this.eduExerciseExamRecordState = 'add';
            },
            checkEduExerciseExamRecord(eduExerciseExamRecordId) {
                console.log(eduExerciseExamRecordId);
                this.currentEduExerciseExamRecordId = eduExerciseExamRecordId;

                this.getEduExerciseExamRecordById();
                this.showDialog = true;
                this.eduExerciseExamRecordState = 'check';
            },
            editEduExerciseExamRecord(eduExerciseExamRecordId) {
                console.log('eduExerciseExamRecord', eduExerciseExamRecordId);
                if (eduExerciseExamRecordId) {
                    this.currentEduExerciseExamRecordId = eduExerciseExamRecordId;
                    this.getEduExerciseExamRecordById();
                } else {
                    this.eduExerciseExamRecord = { ...this.eduExerciseExamRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExerciseExamRecordState = 'edit';
            },
            deleteEduExerciseExamRecord(eduExerciseExamRecordId) {
                let ids = '';
                if (eduExerciseExamRecordId) {
                    ids = eduExerciseExamRecordId;
                } else {
                    ids = this.multipleSelection.map((eduExerciseExamRecord) => eduExerciseExamRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exerciseexamrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExerciseExamRecordList();
                                this.getEduExerciseExamRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExerciseExamRecordList() {
                this.resetEduExerciseExamRecordList();
                this.getEduExerciseExamRecordList();
            },
            getEduExerciseExamRecordList(query = {}) {
                this.loading = true;
                get(`/edu/exerciseexamrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExerciseExamRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExerciseExamRecordById() {
                get(`/edu/exerciseexamrecord/get`,{ id: this.currentEduExerciseExamRecordId }).then((res) =>{
                    if(res.success){
                      this.eduExerciseExamRecord = { ...this.eduExerciseExamRecord, ...res.eduExerciseExamRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExerciseExamRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exerciseexamrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exerciseexamrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exerciseexamrecord/importData`,formData);
              this.refreshEduExerciseExamRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExerciseExamRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExerciseExamRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>